import { Gift, ArrowRight } from "lucide-react";

export default function AnnouncementBar({ onClick }) {
  return (
    <div
      className="relative z-50 overflow-hidden border-b border-blue-500/20 bg-gradient-to-r from-blue-950/90 via-indigo-950/90 to-blue-950/90 backdrop-blur-xl"
      data-testid="announcement-bar"
    >
      {/* Diagonal angled light streaks */}
      <div className="pointer-events-none absolute inset-0" aria-hidden>
        <span className="diag diag-1" />
        <span className="diag diag-2" />
        <span className="diag diag-3" />
      </div>

      <div className="relative mx-auto flex max-w-6xl items-center justify-center gap-3 px-5 py-2.5 md:px-6">
        <div className="flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-500/10 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-widest text-emerald-300">
          <Gift className="h-3.5 w-3.5" />
          Limited offer
        </div>
        <p className="flex-1 text-center text-xs font-medium text-slate-200 sm:text-sm">
          Get <span className="font-bold text-white">started with expert ads — only ₹16/day</span>
          <span className="mx-2 hidden text-slate-500 sm:inline">·</span>
          <span className="hidden text-slate-400 sm:inline">Onboard within 17 minutes</span>
        </p>
        <button
          type="button"
          onClick={onClick}
          className="hidden items-center gap-1.5 rounded-full bg-white/5 px-3 py-1 text-xs font-semibold text-white transition-all hover:bg-white/10 sm:inline-flex"
          data-testid="announcement-claim-btn"
        >
          Register now <ArrowRight className="h-3 w-3" />
        </button>
      </div>

      <style>{`
        .diag {
          position: absolute;
          top: -60%;
          left: -10%;
          width: 4px;
          height: 220%;
          border-radius: 9999px;
          transform: translateX(-20vw) rotate(25deg);
          background: linear-gradient(
            180deg,
            transparent 0%,
            rgba(191, 219, 254, 0.0) 15%,
            rgba(191, 219, 254, 0.85) 48%,
            #ffffff 50%,
            rgba(191, 219, 254, 0.85) 52%,
            rgba(191, 219, 254, 0.0) 85%,
            transparent 100%
          );
          filter: drop-shadow(0 0 8px rgba(191, 219, 254, 0.9))
                  drop-shadow(0 0 16px rgba(59, 130, 246, 0.65));
          animation: diagFly 9s linear infinite;
          will-change: transform, opacity;
          opacity: 0;
        }
        .diag-1 { animation-delay: 0s; }
        .diag-2 { animation-delay: 3s; width: 3px; }
        .diag-3 { animation-delay: 6s; width: 3.5px; }
        @keyframes diagFly {
          0%   { opacity: 0; transform: translateX(-20vw) rotate(25deg); }
          2%   { opacity: 1; }
          30%  { opacity: 1; transform: translateX(110vw) rotate(25deg); }
          31%  { opacity: 0; transform: translateX(110vw) rotate(25deg); }
          100% { opacity: 0; transform: translateX(110vw) rotate(25deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          .diag { display: none; }
        }
      `}</style>
    </div>
  );
}
